import { inject } from '@angular/core';
import type { CanDeactivateFn, CanMatchFn } from '@angular/router';
import { PermissionsService } from '@frontendlib/common/features/permissions/services/permissions.service';
import { type Actions, type Subjects, ViewSubjects } from '@sharedlib/common/permissions/types/Permissions';
import { filter, map, take } from 'rxjs';
import type { FormSharedComponent } from '../components/form-shared.component';
import type { FormsLayoutComponent } from '../components/forms-layout.component';
export const formsCanMatch: CanMatchFn = () => {
  const permissions: PermissionsService<Actions, Subjects> = inject(PermissionsService);
  return permissions.hasPermissionsLoadedObservable.pipe(
    filter(Boolean),
    take(1),
    map(() => permissions.checkPermission('read', ViewSubjects.formsView)),
  );
};
export const formsCanDeactivate: CanDeactivateFn<FormsLayoutComponent> = (component) => component.beforeLeave();

export const formSharedCanDeactivate: CanDeactivateFn<FormSharedComponent> = (component) => component.beforeLeave();
